/**
 * Cabecera `Authorization` de las peticiones GraphQL.
 *
 * Vive fuera de `vue-apollo.js` porque ese módulo construye un httpLink al
 * importarse y no se puede cargar en tests (el mismo invariant que impide
 * montar `login.spec` y `register.spec`). Acá la decisión queda aislada y
 * verificable.
 *
 * La regla: **lo que la operación ponga en su context manda**. El líder entra a
 * /conference sin cuenta, así que no hay token de usuario en el store y su
 * guest token viaja en el context de la mutación. Antes esta función era un
 * spread seguido de `Authorization: token ? ... : ""`, y por el orden de las
 * claves el header del invitado se reemplazaba por cadena vacía: la API
 * respondía EMPTY_TOKEN y su asistencia no se registraba.
 *
 * @param {Object} params
 * @param {Object} [params.headers] - cabeceras que trae la operación
 * @param {String} [params.token] - token del usuario en sesión, si lo hay
 * @returns {Object} cabeceras con Authorization resuelto
 */
export function buildAuthHeaders({ headers = {}, token } = {}) {
  // Presencia de la clave, no truthiness: una operación que manda
  // `Authorization: ""` la está declarando anónima a propósito, y meterle el
  // token del store autenticaría una petición que nadie quiso autenticar.
  if (Object.prototype.hasOwnProperty.call(headers, "Authorization")) {
    return { ...headers };
  }
  return {
    ...headers,
    Authorization: token ? `Bearer ${token}` : "",
  };
}
